import React, { useContext, useEffect, useState } from "react";
import { DocumentContext } from "~context/DocumentContext";

import AppearOnScroll from "~components/AppearOnScroll";
import Parallaxer from "~components/Parallaxer";
import Typer from "~components/Typer";
import { useTimeout } from "~utils/hooks";

const TyperSection = ({
  heading,
  colour = `orange`,
  backgroundColour = `sauvignon`,
  imageColor,
  imageText,
  imageTextColour = `white`,
  imageCaption,
  typerColor
}) => {
  const { scrollTop, windowHeight } = useContext(DocumentContext);

  const [loaded, setLoaded] = useState(false);

  //

  useTimeout(() => {
    setLoaded(true);
  }, 1000);

  let translateY = parseInt(scrollTop * 0.1);

  // todo : remove opacity-0
  // todo : adjust the container whitespace/position/display attributes to get the text wrapping properly
  // todo : tweak to something based on windowHeight/windowWidth maybe
  if (scrollTop > windowHeight) {
    translateY = windowHeight; // should be the end value for the transform effect
  }

  //

  return (
    <AppearOnScroll atTop>
      {({ visible }) => (
        <article className={`w-full relative bg-${backgroundColour}`}>
          <div className="w-full h-full absolute top-0 right-0 bottom-0 left-0 items-start">
            <div className="grid">
              <h1 className="index-page__banner__title grid-end-12 relative z-10 f1 universal-sans text-orange">
                {loaded && visible && <Typer color={colour} text={heading} />}
              </h1>
            </div>
          </div>

          <div
            style={{
              transform: `translateY(${parseInt(-translateY)}px)`
            }}
            className="grid items-end z-10 pb-v2 xs:pb-v7"
          >
            <div className="typer__container grid-end-8 xs:grid-end-8 grid-start-5 xs:grid-start-1 relative">
              <div className={`typer__image p-v1 xs:p-v2 bg-${imageColor} b2`}>
                <div className="w-full h-full absolute top-0 right-0 bottom-0 left-0 items-start overflow-hidden clipped">
                  <div
                    style={{
                      transform: `translateY(${parseInt(translateY)}px)`
                    }}
                    className="w-full h-full fixed top-0 right-0 bottom-0 left-0"
                  >
                    <div className="w-full h-full absolute top-0 right-0 bottom-0 left-0 items-start overflow-hidden clipped">
                      <div className="">
                        <h2 className="index-page__banner__title grid-end-12 relative z-10 f1 universal-sans text-orange">
                          {loaded && visible && (
                            <Typer color={typerColor} text={heading} />
                          )}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`w-full relative self-end text-${imageTextColour}`}
                >
                  <p className="mb-1 b2 universal-sans">{imageText}</p>
                  <p className="b2 universal-sans">{imageCaption}</p>
                </div>
              </div>
            </div>
          </div>
        </article>
      )}
    </AppearOnScroll>
  );
};

export default TyperSection;
